import { render, staticRenderFns } from "./TicketConversation.vue?vue&type=template&id=03c9ec12&scoped=true&lang=pug&"
import script from "./TicketConversation.vue?vue&type=script&lang=js&"
export * from "./TicketConversation.vue?vue&type=script&lang=js&"
import style0 from "./TicketConversation.vue?vue&type=style&index=0&id=03c9ec12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c9ec12",
  null
  
)

export default component.exports